module.exports = __webpack_public_path__ + "static/media/farmacia.9d6cd0c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/empresa/farmacia.svg
// module id = 160
// module chunks = 0